export default "__VITE_PUBLIC_ASSET__f9c99872__"